import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import apiService from '../../../services/apiService';
import './Admin.css';

class Admin extends Component {
    state = {
        employees: [],
        navigateToReister: false,
        searchTerm: '',
    };

    componentDidMount() {
        apiService.get('/users/getAllUsers')
            .then(res => {
                this.setState({ employees: res.data });
            })
            .catch(err => {
                console.error("❌ Failed to fetch users:", err);
            });
    }

    handleDelete = (_id, userNickname) => {
        apiService.delete(`/users/delete/${_id}`)
            .then(() => {
                const updated = this.state.employees.filter(emp => emp._id !== _id);
                alert(`המשתמש ${userNickname} נמחק בהצלחה`);
                this.setState({ employees: updated });
            })
            .catch(err => {
                console.error("❌ Failed to delete user:", err);
                alert("שגיאה במחיקת המשתמש, נסה שנית.");
            });
    };
    handleSearchChange = (e) => {
        this.setState({ searchTerm: e.target.value });
    };

    render() {
        if (this.state.navigateToReister) {
            return <Redirect to="/Reister" />;
        }

        const filteredEmployees = this.state.employees.filter(emp => {
            const search = this.state.searchTerm.toLowerCase();
            return (
                (emp.ID && emp.ID.toLowerCase().includes(search)) ||
                (emp.FirstName && emp.FirstName.toLowerCase().includes(search)) ||
                (emp.LastName && emp.LastName.toLowerCase().includes(search)) ||
                (emp.nickname && emp.nickname.toLowerCase().includes(search)) ||
                (emp.role && emp.role.toLowerCase().includes(search))
            );
        });

        return (
            <div className="admin-container">
                <h2>ניהול עובדים</h2>

                <div style={{ marginBottom: '15px' }}>
                    <button
                        className="button"
                        onClick={() => this.setState({ navigateToReister: true })}
                    >
                        <i style={{ marginLeft: '10px' }} className="fas fa-user-plus"></i>
                        הוספת עובד
                    </button>
                </div>

                <input
                    type="text"
                    placeholder="חפש בטבלה..."
                    value={this.state.searchTerm}
                    onChange={this.handleSearchChange}
                    style={{
                        marginBottom: '20px',
                        padding: '8px',
                        width: '100%',
                        maxWidth: '400px',
                        fontSize: '16px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                        direction: 'rtl',
                    }}
                />

                <div className="table-container">
                    <table className="user-table">
                        <thead>
                            <tr>
                                <th>מספר</th>
                                <th>ת״ז</th>
                                <th>שם מלא</th>
                                <th>כינוי</th>
                                <th>תפקיד</th>
                                <th>מחיקה</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredEmployees.map((emp, index) => (
                                <tr key={emp._id}>
                                    <td>{index + 1}</td>
                                    <td>{emp.ID}</td>
                                    <td>{emp.FirstName} {emp.LastName}</td>
                                    <td>{emp.nickname}</td>
                                    <td>{emp.role}</td>
                                    <td>
                                        <button
                                            className="delete-btn"
                                            onClick={() => this.handleDelete(emp._id, emp.nickname)}
                                        >
                                            מחק
                                        </button>

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
        );
    }
}

export default Admin;
